// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_time_ended = /** @type {(inputs: {}) => string} */ () => {
	return `ended`
};

const de_widget_time_ended = /** @type {(inputs: {}) => string} */ () => {
	return `beendet`
};

const es_widget_time_ended = /** @type {(inputs: {}) => string} */ () => {
	return `terminado`
};

const fr_widget_time_ended = /** @type {(inputs: {}) => string} */ () => {
	return `terminé`
};

const fi_widget_time_ended = /** @type {(inputs: {}) => string} */ () => {
	return `päättynyt`
};

const hi_widget_time_ended = /** @type {(inputs: {}) => string} */ () => {
	return `समाप्त`
};

const ja_widget_time_ended = /** @type {(inputs: {}) => string} */ () => {
	return `終了`
};

const nl_widget_time_ended = /** @type {(inputs: {}) => string} */ () => {
	return `beëindigd`
};

const pt_widget_time_ended = /** @type {(inputs: {}) => string} */ () => {
	return `encerrado`
};

const ro_widget_time_ended = /** @type {(inputs: {}) => string} */ () => {
	return `încheiat`
};

const th_widget_time_ended = /** @type {(inputs: {}) => string} */ () => {
	return `สิ้นสุดแล้ว`
};

const ur_widget_time_ended = /** @type {(inputs: {}) => string} */ () => {
	return `ختم ہو گیا`
};

const zh_hant1_widget_time_ended = /** @type {(inputs: {}) => string} */ () => {
	return `已結束`
};

const da_widget_time_ended = /** @type {(inputs: {}) => string} */ () => {
	return `afsluttet`
};

const it_widget_time_ended = /** @type {(inputs: {}) => string} */ () => {
	return `finito`
};

const vn_widget_time_ended = /** @type {(inputs: {}) => string} */ () => {
	return `đã kết thúc`
};

const ko_widget_time_ended = /** @type {(inputs: {}) => string} */ () => {
	return `종료됨`
};

const tr_widget_time_ended = /** @type {(inputs: {}) => string} */ () => {
	return `sona erdi`
};

const lv_widget_time_ended = /** @type {(inputs: {}) => string} */ () => {
	return `beigusies`
};

const ar_widget_time_ended = /** @type {(inputs: {}) => string} */ () => {
	return `انتهت`
};

const bs_widget_time_ended = /** @type {(inputs: {}) => string} */ () => {
	return `završeno`
};

const sl_widget_time_ended = /** @type {(inputs: {}) => string} */ () => {
	return `končano`
};

const id_widget_time_ended = /** @type {(inputs: {}) => string} */ () => {
	return `berakhir`
};

const sv_widget_time_ended = /** @type {(inputs: {}) => string} */ () => {
	return `avslutad`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_time_ended = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_time_ended(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_time_ended", locale)
	if (locale === "en") return en_widget_time_ended(inputs)
	if (locale === "de") return de_widget_time_ended(inputs)
	if (locale === "es") return es_widget_time_ended(inputs)
	if (locale === "fr") return fr_widget_time_ended(inputs)
	if (locale === "fi") return fi_widget_time_ended(inputs)
	if (locale === "hi") return hi_widget_time_ended(inputs)
	if (locale === "ja") return ja_widget_time_ended(inputs)
	if (locale === "nl") return nl_widget_time_ended(inputs)
	if (locale === "pt") return pt_widget_time_ended(inputs)
	if (locale === "ro") return ro_widget_time_ended(inputs)
	if (locale === "th") return th_widget_time_ended(inputs)
	if (locale === "ur") return ur_widget_time_ended(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_time_ended(inputs)
	if (locale === "da") return da_widget_time_ended(inputs)
	if (locale === "it") return it_widget_time_ended(inputs)
	if (locale === "vn") return vn_widget_time_ended(inputs)
	if (locale === "ko") return ko_widget_time_ended(inputs)
	if (locale === "tr") return tr_widget_time_ended(inputs)
	if (locale === "lv") return lv_widget_time_ended(inputs)
	if (locale === "ar") return ar_widget_time_ended(inputs)
	if (locale === "bs") return bs_widget_time_ended(inputs)
	if (locale === "sl") return sl_widget_time_ended(inputs)
	if (locale === "id") return id_widget_time_ended(inputs)
	if (locale === "sv") return sv_widget_time_ended(inputs)
	return "widget_time_ended"
};